import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, Stack } from '@chakra-ui/react';
import { AppDialog } from '@client/components/misc/AppDialog';
import { DialogConfirmFooter } from '@client/components/misc/DialogConfirmFooter';
import { ShipmentFormRow } from '@client/components/misc/ShipmentFormRow';
import { useApiClient } from '@client/hooks/useApiClient';
import { toastError } from '@client/toaster';
import { callApi } from '@client/utils/apiUtils';
import { ShippingProvider } from '@heirloom/common/constants';
import { useState } from 'react';
import { FaCheck, FaPlus, FaTruck } from 'react-icons/fa6';
const DEFAULT_SHIPMENT = {
    provider: ShippingProvider.UPS,
    tracking: '',
};
export const ConfirmShipmentButton = ({ shortId, onSuccess, }) => {
    const apiClient = useApiClient();
    const [open, setOpen] = useState(false);
    const [pending, setPending] = useState(false);
    const [shipments, setShipments] = useState([
        { ...DEFAULT_SHIPMENT },
    ]);
    const [draftShipments, setDraftShipments] = useState(shipments);
    const openDialog = () => {
        setDraftShipments(shipments);
        setOpen(true);
    };
    const closeDialog = () => {
        const hasUnsavedChanges = JSON.stringify(draftShipments) !==
            JSON.stringify(shipments);
        if (hasUnsavedChanges &&
            !window.confirm('Discard unsaved changes?')) {
            return;
        }
        setOpen(false);
    };
    const confirmDialog = async () => {
        setPending(true);
        const result = await callApi(apiClient.admin.updateOrderShipments({
            params: { shortId },
            body: { shipments: draftShipments },
        }));
        setPending(false);
        if (result.error !== null) {
            toastError('Failed to save shipment. Please try again.');
            return;
        }
        setShipments(draftShipments);
        setOpen(false);
        onSuccess(result.data);
    };
    const updateShipment = (index, shipment) => {
        setDraftShipments((prev) => prev.map((s, i) => (i === index ? shipment : s)));
    };
    const deleteShipment = (index) => {
        setDraftShipments((prev) => prev.filter((_, i) => i !== index));
    };
    const hasBlankTracking = draftShipments.some((shipment) => !shipment.tracking.trim());
    return (_jsxs(_Fragment, { children: [_jsxs(Button, { size: "md", onClick: openDialog, variant: "subtle", children: [_jsx(FaTruck, {}), "Confirm shipment"] }), _jsx(AppDialog, { title: "Shipment Details", open: open, onCancel: closeDialog, pending: pending, size: "md", footer: _jsx(DialogConfirmFooter, { onCancel: closeDialog, onConfirm: confirmDialog, confirmIcon: _jsx(FaCheck, {}), confirmLabel: "Confirm", pending: pending, confirmDisabled: hasBlankTracking }), children: _jsxs(Stack, { gap: 3, children: [draftShipments.map((shipment, index) => (_jsx(ShipmentFormRow, { shipment: shipment, onChange: (s) => updateShipment(index, s), onDelete: () => deleteShipment(index), deletable: draftShipments.length > 1 }, index))), _jsxs(Button, { size: "sm", variant: "subtle", alignSelf: "flex-start", onClick: () => setDraftShipments((prev) => [
                                ...prev,
                                { ...DEFAULT_SHIPMENT },
                            ]), fontSize: 18, disabled: pending, children: [_jsx(FaPlus, {}), "Add package"] })] }) })] }));
};
